import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewEncapsulation,
} from "@angular/core";

@Component({
  selector: "app-uni-dialog",
  templateUrl: "./uni-dialog.component.html",
  //
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UniDialogComponent implements OnInit {
  @Input() pageIcon: string;
  @Input() parent: any;

  @Input() contentTemplate: TemplateRef<any>;
  @Input() footerTemplate: TemplateRef<any>;
  @Input() ignoreBusy: boolean;

  public dialogKey: string;

  constructor() {}

  ngOnInit() {}
}
